import { CcApprovalLevel } from "server/models"
import { inferLiteral } from "client/utils"
import * as types from "./types"

export const setCcModuleApprovalLevelList = (moduleLevelList: types.CcModuleApprovalLevelList) => ({
    type: inferLiteral(types.CC_MODULE_APPROVAL_LEVEL_LIST),
    moduleLevelList,
})
export const setCcApprovalLevelList = (levelList: types.CcApprovalLevelList) => ({
    type: inferLiteral(types.CC_APPROVAL_LEVEL_LIST),
    levelList,
})
export const setCcApprovalLevelEdit = (level: CcApprovalLevel) => ({
    type: inferLiteral(types.CC_APPROVAL_LEVEL_EDIT),
    level,
})
export const setCcApprovalLevelReloadList = (value: boolean) => ({
    type: inferLiteral(types.CC_APPROVAL_LEVEL_RELOAD_LIST),
    value,
})
export const setCcApprovalLevelReloadEdit = (value: boolean) => ({
    type: inferLiteral(types.CC_APPROVAL_LEVEL_RELOAD_EDIT),
    value,
})
